const PageSizeDropdown = () => {
    return <>
        {[5, 10, 25, 50, 100, 500, 999999].map((pageSize) => (
            <option key={pageSize} value={pageSize}>
                Show {pageSize === 999999 ? "All" : pageSize}
            </option>
        ))}
    </>
}
export default PageSizeDropdown